// Vendor
import * as React from 'react';
import { BarSvgProps, ResponsiveBar } from '@nivo/bar';
import { useInView } from 'react-intersection-observer';
import {
  SPOT_BRAND,
  SPOT_CORAL,
  SPOT_GREY_0
} from '@thredup/styleguide/src/variables/colors';

// Internal
import { Bar } from './Bar';
import { data } from './data';
import { DEFAULT_CHART_PROPS } from '@src/config/nivo';

const ChartShiftSpending: React.FC = () => {
  // Hooks
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '-200px 0px'
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const initialData = data.map((d: any) => ({
    ...d,
    more: 1,
    less: -1
  }));

  const chartData = inView ? data : initialData;
  const colors = { more: SPOT_BRAND, less: SPOT_CORAL };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getColors = (bar: any) => (colors as any)[bar.id];

  const barProps: BarSvgProps = {
    ...DEFAULT_CHART_PROPS,
    axisLeft: { tickPadding: 10, tickSize: 0 },
    barComponent: Bar,
    colors: getColors,
    data: chartData,
    enableGridY: true,
    indexBy: 'sector',
    keys: ['less', 'more'],
    layout: 'horizontal',
    legends: [
      {
        dataFrom: 'keys',
        anchor: 'top-left',
        direction: 'row',
        justify: true,
        translateX: 120,
        translateY: -15,
        itemsSpacing: 175,
        itemWidth: 100,
        itemHeight: 20,
        itemDirection: 'right-to-left',
        itemOpacity: 0.85,
        symbolSize: 0
      }
    ],
    margin: { top: 30, right: 290, bottom: 0, left: 140 },
    maxValue: 100,
    minValue: -100,
    theme: {
      ...DEFAULT_CHART_PROPS.theme,
      grid: {
        line: {
          stroke: SPOT_GREY_0,
          strokeWidth: 35
        }
      }
    }
  };

  return (
    <span ref={ref}>
      <ResponsiveBar {...barProps} />
    </span>
  );
};

export { ChartShiftSpending };
